<template>
  <v-menu content-class="qtm-border" offset-y>
    <template v-slot:activator="{ props: activator }">
      <qtm-btn v-bind="activator" secondary>
        Quotes ({{ priceGivenCount }}/{{ quotes.length }} prices given)
        <v-icon location="right">
          mdi-chevron-down
        </v-icon>
      </qtm-btn>
    </template>
    <v-list density="compact">
      <admin-link-list-item v-for="quote in quotes" :key="quote.id" :to="`rfqs/quote/${quote.id}/change/`" with-icon>
        <template v-slot:icon>
          <quote-status-icon :quote="quote" />
        </template>

        <span v-if="quote.vendor">
          {{ quote.vendor.name }}
        </span>
        <span v-else>
          No Vendor
        </span>
      </admin-link-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import AdminLinkListItem from '@/components/admin/admin-link-list-item.vue'
import QuoteStatusIcon from '@/components/admin/quote-status-icon.vue'
import type { Quote } from '@quotetome/materials-api'

export interface Props {
  quotes: Quote[]
}
const props = defineProps<Props>()

const priceGivenCount = computed(() => (props.quotes.filter(quote => quote.response_received === 'price given').length))
</script>

<style lang="scss" scoped>
.align-top {
  vertical-align: top;
}
</style>
